import { render, staticRenderFns } from "./ClientDecodeTaxNumber.vue?vue&type=template&id=edb015fa&"
import script from "./ClientDecodeTaxNumber.vue?vue&type=script&lang=js&"
export * from "./ClientDecodeTaxNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports